import type { FC } from 'react'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

const copy = {
  title: `Curious about Twilio's entire Customer Engagement Platform?`,
  buttonTitle: `Visit Twilio Trust Center`,
  buttonHref: `https://www.twilio.com/en-us/trust-center/`,
}

const CuriousAbout: FC = () => {
  return (
    <SectionBase variant="noCopy">
      <Section.Contents>
        <CopyTextBase centered={true}>
          <CopyText.Heading tag="h3" variant="h4">
            {copy.title}
          </CopyText.Heading>
          <CopyText.Link href={copy.buttonHref}>{copy.buttonTitle}</CopyText.Link>
        </CopyTextBase>
      </Section.Contents>
    </SectionBase>
  )
}

export default CuriousAbout
